import React from 'react';
import { UserRole } from '../../Enums/UserRole';
import { Vacancy } from '../../types';
import { VacancyCardNotAuthorized } from './VacancyCardNotAuthorized';
import { VacancyCardStudent } from './VacancyCardStudent';
import useRole from '../../hooks/useRole';
import { VacancyCardEmployer } from './VacancyCardEmployer';

type VacancyCardProps = {
    vacancy: Vacancy
    role?: string
}

export function VacancyCard({ vacancy }: VacancyCardProps) {
    const {role} = useRole();

    if (role === UserRole.Student)
        return (
            <VacancyCardStudent vacancy={vacancy}/>
        )
    else if (role === UserRole.Manager) 
        return (
            <VacancyCardEmployer vacancy={vacancy}/>
    )
    return (
        <VacancyCardNotAuthorized vacancy={vacancy}/>
    )
}